import type { CaseDto } from "@repo/data-store";
import { Badge } from "@repo/ui/components/ui/badge";
import type { ComponentProps } from "react";

type BadgeVariant = ComponentProps<typeof Badge>["variant"];

const STATUS_LABELS: Record<CaseDto["status"], string> = {
  active: "Active",
  finished: "Finished",
  cancelled: "Cancelled",
  "entered-in-error": "Error",
};

const STATUS_VARIANTS: Record<CaseDto["status"], BadgeVariant> = {
  active: "default",
  finished: "secondary",
  cancelled: "destructive",
  "entered-in-error": "destructive",
};

export function CaseStatusBadge({ status }: { status: CaseDto["status"] }) {
  return <Badge variant={STATUS_VARIANTS[status]}>{STATUS_LABELS[status]}</Badge>;
}
